import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import FejezetEditDto from 'app/admin/fejezet/dto/FejezetEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class FejezetEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'fejezetEditControl';
	}

	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new FejezetEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new FejezetEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	getFeladatCsoportSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getFeladatCsoportSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	getFejezetSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getFejezetSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new FejezetEditService();
